import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_scTable = _resolveComponent("scTable");
    const _component_el_button = _resolveComponent("el-button");
    const _component_el_dialog = _resolveComponent("el-dialog");
    const _directive_loading = _resolveDirective("loading");
    return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择商品",
        modelValue: $data.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.visible = $event),
        "align-center": "",
        width: 800,
        "destroy-on-close": "",
        onClosed: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit('closed'))
    }, {
        footer: _withCtx(()=>[
                _createVNode(_component_el_button, {
                    onClick: _cache[0] || (_cache[0] = ($event)=>$data.visible = false)
                }, {
                    default: _withCtx(()=>[
                            ..._cache[4] || (_cache[4] = [
                                _createTextVNode("取 消", -1)
                            ])
                        ]),
                    _: 1
                }),
                _createVNode(_component_el_button, {
                    type: "primary",
                    loading: $data.isSaveing,
                    onClick: _cache[1] || (_cache[1] = ($event)=>$options.submit())
                }, {
                    default: _withCtx(()=>[
                            ..._cache[5] || (_cache[5] = [
                                _createTextVNode("保 存", -1)
                            ])
                        ]),
                    _: 1
                }, 8, [
                    "loading"
                ])
            ]),
        default: _withCtx(()=>[
                _withDirectives((_openBlock(), _createBlock(_component_scTable, {
                    ref: "table",
                    data: $data.tableData,
                    staticTotal: $data.total,
                    height: "470px",
                    pageSize: $data.queryInfo.pageSize,
                    stripe: "",
                    onPaginationChange: $options.paginationChange,
                    onPageSizeChange: $options.pageSizeChange,
                    onSelectionChange: $options.selectionChange,
                    "row-key": "id"
                }, {
                    default: _withCtx(()=>[
                            _createVNode(_component_el_table_column, {
                                label: "#",
                                type: "selection",
                                width: "55",
                                align: "center",
                                "reserve-selection": ""
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "商品ID",
                                prop: "id",
                                width: "120",
                                align: "center"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "归属部门",
                                prop: "supplier.title",
                                width: "120",
                                align: "center"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "商品名称",
                                prop: "title",
                                align: "center",
                                "min-width": "150"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "商品售价",
                                prop: "title",
                                align: "center",
                                "min-width": "150"
                            }, {
                                default: _withCtx(({ row })=>[
                                        _createTextVNode(_toDisplayString(row.price == 0 ? '--' : `${'￥' + row.price}`), 1)
                                    ]),
                                _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "排序",
                                prop: "order",
                                width: "120",
                                align: "center"
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "是否分成",
                                prop: "title",
                                align: "center",
                                "min-width": "150"
                            }, {
                                default: _withCtx(({ row })=>[
                                        _createTextVNode(_toDisplayString(row.commission_type == 0 ? '不分成' : '分成'), 1)
                                    ]),
                                _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "更新时间",
                                prop: "created_at",
                                align: "center",
                                "min-width": "150"
                            })
                        ]),
                    _: 1
                }, 8, [
                    "data",
                    "staticTotal",
                    "pageSize",
                    "onPaginationChange",
                    "onPageSizeChange",
                    "onSelectionChange"
                ])), [
                    [
                        _directive_loading,
                        $data.isLoading
                    ]
                ])
            ]),
        _: 1
    }, 8, [
        "modelValue"
    ]);
}
